export default {
  state: {
    menteeDetail: {},
    menteeList: []
  },
  getters: {
    menteeListDetail: state => num => {
      return state.menteeList.filter(item => item.menteeNum === num)[0]
    }
  },
  mutations: {
    setMenteeDetail (state, detail) {
      state.menteeDetail = detail
    },
    setMenteeList (state, list) {
      state.menteeList = list
    }
  }
}
